import { LoaderService } from './../../../../../_services/loader.service';
import { saveAs } from 'file-saver';
import { CmsService } from './../../../../../_services/strapi.service';
import { Component, inject, OnInit } from '@angular/core';
import { File, Plugin } from 'src/app/_models/strapi-file';

@Component({
    selector: 'app-plugin-download',
    templateUrl: './plugin-download.component.html',
    styleUrls: ['./plugin-download.component.scss'],
    standalone: false
})

export class PluginDownloadComponent implements OnInit {
  private readonly cmsService: CmsService = inject(CmsService);
  private readonly loaderService: LoaderService = inject(LoaderService);

  pluginsVersion: any;
  plugins: Array<Plugin>;

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.cmsService.getPlugins().subscribe(
      resp => {
      this.plugins = resp;
      this.loaderService.stopLoader();
    },
    error => this.loaderService.stopLoader());
  }

  downloadPlugin(file: File) {
    if (!file) {
      return;
    } else {
      this.cmsService.downloadPrivateFile(file.url).subscribe(blob => saveAs(blob, `${file.name}`));
    }
  }

  getIconUrl(file: File): string {
    return this.cmsService.getPrivateFileProxyUrl(file?.url || '');
  }

}
